
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/login",
      function () {
        return require("private-next-pages/user/login.tsx");
      }
    ]);
  